import React, { PropsWithChildren, useEffect, useRef } from 'react';

import { useRouter } from 'next/router';

import { persistLandingPage, persistWebReferrer } from './session-params';

type Props = PropsWithChildren<{}>;

const formPathRegex = /^\/chci-(koupit|hypoteku|prodat|nabidku|odhad)/;

const getRawPath = (pathWithQuery: string) => {
  return pathWithQuery?.split('?')[0];
};

export const Session = ({ children }: Props) => {
  const router = useRouter();

  const prevPage = useRef(getRawPath(router.asPath));
  const firstRender = useRef(true);

  // landing page
  useEffect(() => persistLandingPage(false), []);

  // web referrer
  useEffect(() => {
    // current page is a form and previous page was not a form
    // or it is first render
    if (
      (router.asPath.match(formPathRegex) &&
        !prevPage.current.match(formPathRegex)) ||
      firstRender.current
    ) {
      // when it is first render we don't want to override stored webReferrer
      persistWebReferrer(prevPage.current, !firstRender.current);
    }

    prevPage.current = getRawPath(router.asPath);
    firstRender.current = false;
  }, [router]);

  return <>{children}</>;
};
